export const villaData = {
  villas: [
    {
      id: "villa-1012",
      name: "Premium Villa – 1012 Sq. Ft.",
      villaType: "22.5' × 45' Villa",
      bhk: 3,
      areaSqFt: 1012,
      price: {
        label: "₹ 74.75 Lacs",
        value: 7475000,
      },
      description: "Compact premium villa with efficient layout, natural ventilation, and modern design.",
      features: ["3 Bedrooms", "Efficient Layout", "Modern Design"],
      image: "/images/villaimages/1012_1.jpg",
      images: [
        "/images/villaimages/1012sqft_layout.jpg",
        "/images/villaimages/1012sqft.jpg"
      ],
      status: "Available",
      detail: {
        title: "1012 sqft Villa – Cozy & Efficient Living",
        intro:
          "The 1012 sq ft villa at Floret Town is thoughtfully crafted for those who appreciate intelligent design, comfort, and classical elegance in a compact format. This villa is ideal for small families, professionals, or investors looking for a refined living space within a well-planned township. Despite its efficient footprint, the villa offers a sense of openness, warmth, and privacy, making everyday living both comfortable and aesthetically pleasing.",
        sections: [
          {
            heading: "Architectural Design",
            content:
              "Inspired by classical architectural principles, the villa features clean proportions, balanced elevations, and refined detailing that add timeless appeal. The exterior design blends harmoniously with landscaped surroundings, ensuring the villa feels connected to nature while maintaining its individual character.",
          },
          {
            heading: "Layout & Space Planning",
            content:
              "The villa is spread across a well-planned ground and first floor layout. The living and dining areas are positioned to allow smooth movement and interaction, while bedrooms are thoughtfully placed to ensure privacy and relaxation. Adequate windows and ventilation points ensure natural light flows through the home throughout the day.",
          },
          {
            heading: "Interior Specifications & Finishes",
            list: [
              "Living & Dining Areas: Premium vitrified tile flooring with matching skirting, POP-finished walls painted with acrylic emulsion, and oil-bound distemper ceilings create a bright and elegant atmosphere.",
              "Bedrooms: Designed for comfort, bedrooms feature vitrified flooring, soft wall tones, and proper ventilation for restful living.",
              "Kitchen: Equipped with anti-skid ceramic tile flooring, tiled backsplash up to counter level, and provision for a modern modular kitchen layout.",
              "Bathrooms: Finished with anti-skid flooring, ceramic wall tiles up to dado height, granite counters, premium sanitary ware, glass shower partitions, and sensor lighting for enhanced convenience.",
            ],
          },
          {
            heading: "Construction Quality",
            list: [
              "Earthquake-resistant RCC structure designed as per BIS seismic guidelines",
              "Reinforced concrete foundations ensuring long-term structural stability",
              "Durable doors, windows, and fittings designed for daily use",
            ],
          },
          {
            heading: "Lifestyle Experience",
            content:
              "Surrounded by landscaped greenery and tranquil pathways, the 1012 sq ft villa offers a peaceful residential environment while remaining close to township amenities and daily conveniences.",
          },
          {
            heading: "Why Choose This Villa",
            list: [
              "Ideal compact luxury villa",
              "High construction quality with RCC structure",
              "Surrounded by landscaped green spaces",
            ],
          },
        ],
      },
    },

    {
      id: "villa-1125",
      name: "Premium Villa – 1125 Sq. Ft.",
      villaType: "25' × 45' Villa",
      bhk: 3,
      areaSqFt: 1125,
      price: {
        label: "₹ 86.25 Lacs",
        value: 8625000,
      },
      description: "Spacious villa with enhanced living space and premium specifications.",
      features: ["3 Bedrooms", "Spacious Living", "Premium Finish"],
      image: "/images/villaimages/1125_1.jpg",
      images: [
        "/images/villaimages/1125sqft_layout.jpg",
        "/images/villaimages/1125sqft.jpg"
      ],
      status: "Available",
      detail: {
        title: "1125 sqft Villa – Balanced Comfort for Modern Families",
        intro:
          "The 1125 sq ft villa is designed for families seeking a harmonious balance between space, elegance, and functionality. With well-defined interiors and classical architectural detailing, this villa provides a welcoming environment that adapts effortlessly to modern living needs. Ideal for Families looking for a premium villa in a gated township with long-term value.",
        sections: [
          {
            heading: "Design Philosophy",
            content:
              "The design emphasizes comfort and flow, ensuring that every space serves a clear purpose. Classical elements on the exterior complement contemporary interiors, creating a home that feels both timeless and practical.",
          },
          {
            heading: "Layout & Planning",
            content:
              "The villa features spacious living and dining areas that encourage family interaction, along with well-sized bedrooms that offer privacy. The kitchen layout is designed to be efficient while allowing scope for customization.",
          },
          {
            heading: "Interior Features",
            list: [
              "Large-format vitrified tiles in living spaces enhance brightness and visual appeal",
              "Acrylic emulsion paint over POP-finished walls for a refined look",
              "Bathrooms fitted with premium CP fittings, anti-skid tiles, granite counters, and modern sanitary ware",
              "Provision for geysers, exhausts, and contemporary lighting solutions",
            ],
          },
          {
            heading: "Structural & Material Quality",
            list: [
              "RCC structure with seismic safety considerations",
              "High-quality electrical wiring and concealed plumbing",
              "Durable external wall finishes suitable for long-term maintenance",
            ],
          },
        ],
      },
    },

    {
      id: "villa-1250",
      name: "Premium Villa – 1250 Sq. Ft.",
      villaType: "25' × 50' Villa",
      bhk: 3,
      areaSqFt: 1250,
      price: {
        label: "₹ 1.03 Cr",
        value: 10350000,
      },
      description: "Well-planned villa offering balanced space, comfort, and elegant design.",
      features: ["3 Bedrooms", "Wide Layout", "Elegant Design"],
      image: "/images/villaimages/03-VILLAOF25X50_1.jpg",
      images: [
        "/images/villaimages/1250sqft_layout.jpg",
        "/images/villaimages/1250sqft.jpg"
      ],
      status: "Available",
      detail: {
        title: "1250 sq ft Villa – Refined Living with Enhanced Space",
        intro:
          "The 1250 sq ft villa is ideal for growing families who desire additional space without compromising on design aesthetics. It offers an elevated living experience with carefully planned interiors and premium specifications that enhance everyday comfort.",
        sections: [
          {
            heading: "Architectural Appeal",
            content:
              "The villa reflects classical refinement through symmetrical planning and understated detailing. The exterior blends seamlessly with landscaped surroundings, offering a serene and elegant presence within the township.",
          },
          {
            heading: "Interior Experience",
            list: [
              "Spacious living and dining zones designed for comfort and gatherings",
              "Bedrooms that offer ample space for storage and relaxation",
              "A functional kitchen layout with provision for modular fittings",
              "Bathrooms featuring branded sanitary ware, glass partitions, and quality finishes",
            ],
          },
          {
            heading: "Construction & Safety",
            list: [
              "BIS-compliant earthquake-resistant RCC structure",
              "Reinforced foundations and durable building materials",
              "Carefully planned electrical and plumbing systems for reliability",
            ],
          },
        ],
      },
    },

    {
      id: "villa-1500",
      name: "Premium Villa – 1500 Sq. Ft.",
      villaType: "30' × 50' Villa",
      bhk: 4,
      areaSqFt: 1500,
      price: {
        label: "₹ 1.20 Cr",
        value: 12000000,
      },
      description: "Family-friendly villa with large interiors and premium lifestyle features.",
      features: ["4 Bedrooms", "Large Interiors", "Premium Living"],
      image: "/images/villaimages/1500sqf.jpeg",
      images: [
        "/images/villaimages/1500sqft_layout.jpg",
        "/images/villaimages/1500_1.jpg"
      ],
      status: "Limited Units",
      detail: {
        title: "1500 sq ft Villa – Spacious Living in a Serene Setting",
        intro:
          "The 1500 sq ft villa offers a noticeable upgrade in space and comfort, making it suitable for families seeking a more relaxed and premium lifestyle. Designed with attention to detail, this villa provides generous interiors and a calm living environment.",
        sections: [
          {
            heading: "Space & Layout",
            content:
              "Larger living and dining areas allow for comfortable hosting and family activities, while bedrooms are thoughtfully positioned to maintain privacy. The layout ensures a seamless balance between open areas and private zones.",
          },
          {
            heading: "Interior Specifications",
            list: [
              "Premium vitrified flooring throughout living and bedroom spaces",
              "Anti-skid ceramic tiles in kitchens and bathrooms",
              "Granite countertops and high-quality sanitary fittings",
              "Well-designed staircase finished with Indian/Kota stone",
            ],
          },
          {
            heading: "Environment & Ambience",
            content:
              "Set amidst landscaped gardens inspired by floral themes, the villa enjoys a refreshing atmosphere that enhances daily living and well-being.",
          },
        ],
      },
    },

    {
      id: "villa-1800",
      name: "Premium Villa – 1800 Sq. Ft.",
      villaType: "30' × 60' Villa",
      bhk: 4,
      areaSqFt: 1800,
      price: {
        label: "₹ 1.40 Cr",
        value: 14000000,
      },
      description: "Luxury villa with expansive rooms, excellent ventilation, and elegant layout.",
      features: ["4 Bedrooms", "Luxury Layout", "Spacious Rooms"],
      image: "/images/villaimages/1800_.jpeg",
      images: [
        "/images/villaimages/1800sqft_layout.jpg",
        "/images/villaimages/05-VILLAOF30x60_1.jpg",
        "/images/villaimages/05-VILLAOF30x60_3.jpg",
      ],
      status: "Limited Units",
      detail: {
        title: "1800 sq ft Villa – Elegant Living with Superior Comfort",
        intro:
          "The 1800 sq ft villa is crafted for homeowners who value spacious interiors, refined finishes, and architectural elegance. Every element of this villa is designed to offer a comfortable yet luxurious lifestyle.",
        sections: [
          {
            heading: "Design Highlights",
            list: [
              "Expansive living and dining spaces",
              "Well-proportioned bedrooms with premium finishes",
              "Functional kitchen with ample working space",
              "Wide staircases with quality railing finishes",
            ],
          },
          {
            heading: "Premium Specifications",
            list: [
              "Superior vitrified flooring and acrylic wall finishes",
              "Branded CP fittings and modern bathroom accessories",
              "High-quality electrical fittings and concealed wiring",
            ],
          },
        ],
      },
    },

    {
      id: "villa-2450",
      name: "Luxury Villa – 2450 Sq. Ft.",
      villaType: "35' × 70' Villa",
      bhk: 5,
      areaSqFt: 2450,
      price: {
        label: "₹ 2.30 Cr",
        value: 23000000,
      },
      description: "Ultra-spacious luxury villa designed for elite living with expansive interiors.",
      features: ["5 Bedrooms", "Luxury Living", "Elite Design"],
      image: "/images/villaimages/2450_1.jpg",
      images: [
        "/images/villaimages/2450sqft_layout.jpg",
        "/images/villaimages/2450sqft.jpg",
        "/images/villaimages/06-VILLAOF35X70_1.jpg"
         
      ],
      status: "Available",
      detail: {
        title: "2450 sq ft Villa – Premium Classical Family Residence",
        intro:
          "The 2450 sq ft villa reflects grandeur and sophistication through its generous layout and classical design language. Ideal for larger families, this villa offers a distinguished living experience within Floret Town.",
        sections: [
          {
            heading: "Interior & Exterior Features",
            list: [
              "Grand living areas designed for comfort and elegance",
              "Multiple spacious bedrooms with premium finishes",
              "Stylish bathrooms with glass partitions and sensor lighting",
              "Landscaped outdoor areas enhancing visual appeal",
            ],
          },
          {
            heading: "Private Swimming Pool – Your Leisure Retreat",
            content:
              "What sets this villa apart is the private swimming pool—an oasis of relaxation and luxury. Whether it’s a weekend dip or a refreshing start to your morning, this pool enhances your lifestyle and brings resort-style living to your doorstep.",
          },
          {
            heading: "Construction Excellence",
            list: [
              "Seismic-resistant RCC structure",
              "Reinforced concrete foundations",
              "Durable external finishes ensuring longevity",
              "RCC structure with seismic safety compliance",
              "Vitrified tile flooring in living and bedrooms",
              "Anti-skid ceramic tiles in kitchens and bathrooms",
              "Acrylic emulsion wall finishes with POP",
              "Premium CP fittings and sanitary ware",
              "Well-planned electrical and plumbing systems",
            ],
          },
        ],
      },
    },

    {
      id: "villa-3600",
      name: "Premium Villa – 45 × 80",
      villaType: "45' × 80' Premium Villa",
      bhk: 4,
      areaSqFt: 3600,
      price: {
        label: "Coming Soon",
        value: null,
      },
      description:
        "Spacious premium villa with grand frontage and thoughtfully planned interiors. Launching soon.",
      features: ["Premium Frontage", "Spacious Layout", "Modern Design"],
      image: "/villa8.png",
      status: "Coming Soon",
      detail: {
        title: "3600 sq ft Villa – Grand Living with Architectural Prestige",
        intro: "Coming Soon",
        sections: [],
      },
    },

    {
      id: "villa-4400",
      name: "Signature Villa – 4400 Sq. Ft.",
      villaType: "55' × 80' Villa",
      bhk: 6,
      areaSqFt: 4400,
      price: {
        label: "₹ 4.60 Cr",
        value: 46000000,
      },
      description:
        "Exclusive signature villa with grand proportions, premium architecture, and luxury finishes.",
      features: ["6 Bedrooms", "Ultra Luxury", "Grand Layout", "Premium Architecture"],
      image: "/images/villaimages/4400sqft.jpg",
      images: [
        "/images/villaimages/4400sqft_layout.jpg",
        "/images/villaimages/08-VILLAOF55X80_1.jpg",
         
        
      ],
      status: "Limited Units",
      detail: {
        title: "4400 sq ft Villa – Ultra-Luxury Signature Living",
        intro:
          "This villa is designed in the classical architectural style, featuring grand proportions, symmetrical facades, and timeless details that reflect elegance and sophistication. The villa’s roof is adorned with striking red-coloured tiles, adding a regal charm to its exterior while ensuring durability and climate resilience. Spanning across a well-planned 55’ x 80’ layout, the villa comprises five spacious rooms, a grand living area, and a modern kitchen all designed to offer luxury and comfort. A private swimming pool enhances the leisure experience, creating a perfect blend of relaxation and recreation. Each villa is thoughtfully enveloped by lush, landscaped gardens, allowing residents to connect with nature. The carefully curated green spaces enhance the visual appeal and provide a serene and tranquil living experience.",
        sections: [
          {
            heading: "Architectural & Interior Excellence",
            list: [
              "Expansive living and dining halls ideal for entertaining",
              "Multiple large bedrooms with luxury finishes",
              "Premium materials used across flooring, walls, and fittings",
              "Landscaped surroundings enhancing privacy and exclusivity",
            ],
          },
          {
            heading: "Structural & Safety Standards",
            list: [
              "BIS-compliant earthquake-resistant RCC construction",
              "High-grade materials ensuring durability and long-term value",
              "Designed to offer comfort, safety, and prestige",
            ],
          },
        ],
      },
    },
  ],
};











// export const villaData = {
//   section: {
//     title: "Premium Villas",
//     subtitle:
//       "Choose from multiple villa configurations designed for modern living"
//   },

//   villas: [
//     {
//       id: "villa-1012",
//       name: "Premium Villa – 1012 Sq. Ft.",
//       villaType: "22.5' × 45' Villa",
//       bhk: 3,
//       areaSqFt: 1012,
//       price: {
//         label: "₹ 74.75 Lacs",
//         value: 7475000
//       },
//       description:
//         "Compact premium villa with efficient layout, natural ventilation, and modern design.",
//       features: ["3 Bedrooms", "Efficient Layout", "Modern Design"],
//       image: "/villa1.png",
//       status: "Available"
//     },

//     {
//       id: "villa-1125",
//       name: "Premium Villa – 1125 Sq. Ft.",
//       villaType: "25' × 45' Villa",
//       bhk: 3,
//       areaSqFt: 1125,
//       price: {
//         label: "₹ 86.25 Lacs",
//         value: 8625000
//       },
//       description:
//         "Spacious villa with enhanced living space and premium specifications.",
//       features: ["3 Bedrooms", "Spacious Living", "Premium Finish"],
//       image: "/villa2.png",
//       status: "Available"
//     },

//     {
//       id: "villa-1250",
//       name: "Premium Villa – 1250 Sq. Ft.",
//       villaType: "25' × 50' Villa",
//       bhk: 3,
//       areaSqFt: 1250,
//       price: {
//         label: "₹ 1.03 Cr",
//         value: 10350000
//       },
//       description:
//         "Well-planned villa offering balanced space, comfort, and elegant design.",
//       features: ["3 Bedrooms", "Wide Layout", "Elegant Design"],
//       image: "/villa3.png",
//       status: "Available"
//     },

//     {
//       id: "villa-1500",
//       name: "Premium Villa – 1500 Sq. Ft.",
//       villaType: "30' × 50' Villa",
//       bhk: 4,
//       areaSqFt: 1500,
//       price: {
//         label: "₹ 1.20 Cr",
//         value: 12000000
//       },
//       description:
//         "Family-friendly villa with large interiors and premium lifestyle features.",
//       features: ["4 Bedrooms", "Large Interiors", "Premium Living"],
//       image: "/villa4.png",
//       status: "Limited Units"
//     },

//     {
//       id: "villa-1800",
//       name: "Premium Villa – 1800 Sq. Ft.",
//       villaType: "30' × 60' Villa",
//       bhk: 4,
//       areaSqFt: 1800,
//       price: {
//         label: "₹ 1.40 Cr",
//         value: 14000000
//       },
//       description:
//         "Luxury villa with expansive rooms, excellent ventilation, and elegant layout.",
//       features: ["4 Bedrooms", "Luxury Layout", "Spacious Rooms"],
//       image: "/villa5.png",
//       status: "Limited Units"
//     },

//     {
//       id: "villa-2450",
//       name: "Luxury Villa – 2450 Sq. Ft.",
//       villaType: "35' × 70' Villa",
//       bhk: 5,
//       areaSqFt: 2450,
//       price: {
//         label: "₹ 2.30 Cr",
//         value: 23000000
//       },
//       description:
//         "Ultra-spacious luxury villa designed for elite living with expansive interiors.",
//       features: ["5 Bedrooms", "Luxury Living", "Elite Design"],
//       image: "/villa6.png",
//       status: "Available"
//     },

//     {
//       id: "villa-4400",
//       name: "Signature Villa – 4400 Sq. Ft.",
//       villaType: "55' × 80' Villa",
//       bhk: 6,
//       areaSqFt: 4400,
//       price: {
//         label: "₹ 4.60 Cr",
//         value: 46000000
//       },
//       description:
//         "Exclusive signature villa with grand proportions, premium architecture, and luxury finishes.",
//       features: [
//         "6 Bedrooms",
//         "Ultra Luxury",
//         "Grand Layout",
//         "Premium Architecture"
//       ],
//       image: "/villa7.png",
//       status: "Limited Units"
//     },
//     {
//   id: "villa-3600",
//   name: "Premium Villa – 45 × 80",
//   villaType: "45' × 80' Premium Villa",
//   bhk: 4,
//   areaSqFt: 3600,
//   price: {
//     label: "Coming Soon",
//     value: null
//   },
//   description:
//     "Spacious premium villa with grand frontage and thoughtfully planned interiors. Launching soon.",
//   features: ["Premium Frontage", "Spacious Layout", "Modern Design"],
//   image: "/villa8.png",
//   status: "Coming Soon"
// },
// {
//   id: "villa-11200",
//   name: "Luxury Villa – 80 × 140",
//   villaType: "80' × 140' Luxury Villa",
//   bhk: 6,
//   areaSqFt: 11200,
//   price: {
//     label: "Coming Soon",
//     value: null
//   },
//   description:
//     "Ultra-luxury villa with expansive land area, elite architecture, and unmatched exclusivity. Coming soon.",
//   features: [
//     "Ultra Luxury",
//     "Grand Plot",
//     "Elite Architecture",
//     "Private Landscape"
//   ],
//   image: "/villa9.png",
//   status: "Coming Soon"
// }

//   ]
// };
